import React, { useEffect, useState } from "react";
import {
  Box,
  Card,
  CardContent,
  Typography,
  Button,
  TextField,
  Autocomplete,
  CircularProgress,
} from "@mui/material";
import { Add } from "@mui/icons-material";
import { db, auth } from "../../firebase";
import { collection, doc, getDocs, query, where } from "firebase/firestore";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";

function Admissionprocess() {
  const [students, setStudents] = useState([]);
  const [selectedStudent, setSelectedStudent] = useState(null);
  const [schoolId, setSchoolId] = useState(null);
  const [loading, setLoading] = useState(true);

  const navigate = useNavigate();

  /* ================= FETCH SCHOOL ID ================= */
  useEffect(() => {
    const fetchSchoolId = async () => {
      const user = auth.currentUser;
      if (!user) return;

      const q = query(collection(db, "users"), where("uid", "==", user.uid));
      const snap = await getDocs(q);
      if (!snap.empty) {
        const data = snap.docs[0].data();
        setSchoolId(data.schoolId);
      }
    };
    fetchSchoolId();
  }, []);

  /* ================= FETCH STUDENTS ================= */
  useEffect(() => {
    if (!schoolId) return;
    const fetchStudents = async () => {
      setLoading(true);
      try {
        const q = query(collection(db, "admissionEnquiries"), where("schoolId", "==", schoolId));
        const snap = await getDocs(q);
        const arr = snap.docs.map((d) => ({ id: d.id, ...d.data() }));
        setStudents(arr);
      } catch (err) {
        console.log(err);
        Swal.fire("Error", "Failed to fetch students", "error");
      }
      setLoading(false);
    };
    fetchStudents();
  }, [schoolId]);

  const startAdmission = () => {
    if (!selectedStudent) {
      Swal.fire("Error", "Please select a student", "error");
      return;
    }
    // Navigate to admission process page with selected student id
    navigate(`/admission/${selectedStudent.id}`);
  };

  const directAdmission = () => {
    // 1. Create a reference to a new document in the "students" collection
    const newStudentRef = doc(collection(db, "students"));

    // 2. Extract the auto-generated unique ID
    const newUniqueId = newStudentRef.id;

    // 3. Navigate to the admission page with this specific ID instead of "new"
    navigate(`/admission/${newUniqueId}`);
  };

  return (
    <Box p={1}>
      <Typography variant="h5" fontWeight={800} mb={2}>
        Start Admission Process
      </Typography>

      <Card sx={{ p: 2, mb: 3 }}>
        <Autocomplete
          options={students}
          getOptionLabel={(option) => option.studentName || ""}
          value={selectedStudent}
          onChange={(e, newValue) => setSelectedStudent(newValue)}
          loading={loading}
          renderInput={(params) => (
            <TextField
              {...params}
              label="Select Student"
              size="small"
              placeholder="Search student by name"
              InputProps={{
                ...params.InputProps,
                endAdornment: (
                  <>
                    {loading ? <CircularProgress color="inherit" size={20} /> : null}
                    {params.InputProps.endAdornment}
                  </>
                ),
              }}
            />
          )}
        />

        <Button
          variant="contained"
          startIcon={<Add />}
          sx={{ mt: 2 }}
          onClick={startAdmission}
        >
          Start Admission Process
        </Button>
        <Button
          variant="outlined"
          startIcon={<Add />}
          sx={{ mt: 2, ml: 2 }}
          onClick={directAdmission}
        >
          Direct Admission
        </Button>
      </Card>
    </Box>
  );
}

export default Admissionprocess;